import React from 'react';
import workspaceQuery from '../../../graphql/queries/nominal/NominalWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/nominal/NominalListQuery.graphql';
import instanceQuery from '../../../graphql/queries/nominal/NominalQuery.graphql';
import defaultQuery from '../../../graphql/queries/nominal/NominalDefault.graphql';
import mutationQuery from '../../../graphql/mutations/nominal/NominalMutation.graphql';
import aggregateQuery from '../../../graphql/queries/nominal/NominalAggregateQuery.graphql';
import fragment from '../../../graphql/fragments/nominal/NominalFragment.graphql';
import mutationTempQuery from '../../../graphql/mutations/nominal/NominalTemporaryMutation.graphql';
import { workspaceActionsForPermissions } from '../../../actions/nominal/NominalWorkspaceAction';
import { FilterOperation, IFilterInput, INominal } from '../../schema/p4types';
import { EntityType, IDropdownOptionRenderer } from '../../../@types/entityTypes';

//TODO - Can we replace uses of this with 'NominalOptionRenderer'? Does it harm any use to include the name? (See also - BasicSupplierOptionRenderer)
//(Kept separate for the moment to avoid unnecessary changes to user experience)
export const BasicNominalOptionRenderer = ({ option }: { option: INominal }) => {
  return <span>{option?.accountNo}</span>;
};

const NominalOptionRenderer: IDropdownOptionRenderer = ({ option }: { option: INominal | Array<INominal> }) => {
  if (Array.isArray(option)) {
    const content = option.map((value) => value?.accountNo).join(', ');
    return <span>{content}</span>;
  }
  return (
    <span>
      {option?.accountNo} {option?.name}
    </span>
  );
};

const Nominal: EntityType & { balanceSheetFilter: Array<IFilterInput>; profitLossFilter: Array<IFilterInput> } = {
  type: 'Nominal',
  title: 'Accounts',
  formTitle: 'Account',
  formUrl: '/Nominal/Accounts/Details/',
  workspaceUrl: '/Nominal/Accounts/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporaryUpdate: mutationTempQuery,
  notificationKey: 'accountNo',
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'accountNo',
    optionRenderer: NominalOptionRenderer,
    valueRenderer: NominalOptionRenderer,
    filterOption: () => true, //Override Default
    remoteFilter: true,
    placeholder: 'Search nominal',
    pageView: false,
    asButton: false,
    selectModal: 'NominalWorkspace',
  },
  aggregate: aggregateQuery,
  fragment,
  balanceSheetFilter: [
    {
      filterOperation: FilterOperation.Equals,
      filterParameters: {
        field: `accountType`,
        value: 'BALANCE_SHEET',
      },
    },
  ],
  profitLossFilter: [
    {
      filterOperation: FilterOperation.Equals,
      filterParameters: {
        field: `accountType`,
        value: 'PROFIT_LOSS',
      },
    },
  ],
  screenReference: 'NOMINAL_ACCOUNTS',
  actions: workspaceActionsForPermissions,
};

export default Nominal;
